class FilterTag
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'filter-tag--bound'
            @.$deleteButton = @.$el.querySelector 'button'

            @.filterType = @.$el.dataset?.filterType ? 'filter'
            @.filterValue = @.$el.dataset?.filterValue ? 'filter'

            @.$el.classList.add 'filter-tag--bound'
            @.InitEvents()
        return
    
    InitEvents: ->
        self = @
        @.$el.addEventListener 'filter-tag-remove', (e) ->
            self.Remove()
            return

        @.$deleteButton.addEventListener 'click', (e) ->
            e.preventDefault()
            self.$el.dispatchEvent new CustomEvent 'filter-tag-delete', {
                bubbles: false
                detail: {
                    filterType: self.filterType
                    filterValue: self.filterValue
                    text: self.$el.textContent
                }
            }
            self.Remove()
        return
    
    Remove: ->
        @.$el.remove()
        delete @
        return

BindFilterTags = ->
    document.querySelectorAll '.filter-tag:not(.filter-tag--bound)'
        .forEach (el) ->
            new FilterTag el
            return
    return

window.addEventListener 'bind-components', BindFilterTags

class FilterTagCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.deleteTitle = options?.deleteTitle ? 'Filter entfernen'
        @.filterType = options?.filterType ? 'filter'
        @.filterValue = options?.filterValue ? 'filter'
        @.tag = options?.tag ? 'div'
        @.text = options?.text ? 'Filter'

        @.CreateElement()
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement @.tag
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        @.$el.classList.add 'filter-tag'
        @.$el.innerHTML = "
            #{ @.text }
            <button type='button' aria-label='#{ @.deleteTitle }' title='#{ @.deleteTitle }'></button>
        "
        @.$el.dataset.filterType = @.filterType
        @.$el.dataset.filterValue = @.filterValue
        return

window.CreateFilterTag = (options) ->
    return new FilterTagCreate options